import {
  collection,
  doc,
  setDoc,
  serverTimestamp,
  Timestamp,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { AuditLogCreateInput, AuditAction, AuditEntityType } from '@/types';

const COLLECTION = 'auditLogs';

export interface LogEventParams {
  entityType: AuditEntityType;
  entityId: string;
  action: AuditAction;
  tenantId: string | null;
  companyId?: string | null;
  performedBy: string;
  performedByEmail?: string;
  previousValue?: Record<string, unknown>;
  newValue?: Record<string, unknown>;
  metadata?: Record<string, unknown>;
}

export async function logEvent(params: LogEventParams): Promise<void> {
  try {
    const entry: Omit<AuditLogCreateInput, 'performedAt'> & { performedAt: ReturnType<typeof serverTimestamp> } = {
      ...params,
      performedAt: serverTimestamp() as unknown as ReturnType<typeof serverTimestamp>,
    };
    const ref = doc(collection(db, COLLECTION));
    await setDoc(ref, entry);
  } catch (err) {
    // Never let audit logging break the main flow
    console.error('[audit] Failed to log event:', err);
  }
}

export function fromTimestamp(ts: Timestamp | string): string {
  if (typeof ts === 'string') return ts;
  return ts.toDate().toISOString();
}
